module.exports = __webpack_public_path__ + "img/question-icon.69f347a7.svg";